import { render, staticRenderFns } from "./ResourceQuota.vue?vue&type=template&id=475fbdd4&scoped=true"
import script from "./ResourceQuota.vue?vue&type=script&lang=js"
export * from "./ResourceQuota.vue?vue&type=script&lang=js"
import style0 from "./ResourceQuota.vue?vue&type=style&index=0&id=475fbdd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475fbdd4",
  null
  
)

export default component.exports